export const DirectBookingEngineTab = {
  websiteSettings: 'website-settings',
  customDomain: 'custom-domain',
};

export type DirectBookingEngineTabType =
  (typeof DirectBookingEngineTab)[keyof typeof DirectBookingEngineTab];

export const WebsiteSettingsModalPath = {
  navigation: 'navigation',
  colors: 'colors',
};
